import { ReactElement } from 'react';
import { MenuItem } from '@cad-arc';
import { FrExportsNotificationsCounter } from './fr-exports-notification-counter';
import { FrExportsMenuItemProps } from '../../layout/components/types';

export function FrExportsMenuItem({
    notificationCount,
    onExportItemClick,
}: FrExportsMenuItemProps): ReactElement {
    return (
        <MenuItem
            leadingVisual="Export"
            data-testid="export-nav-link-nav"
            onClick={onExportItemClick}
            style={{ position: 'relative' }}
        >
            Exports
            <FrExportsNotificationsCounter
                notificationCount={notificationCount}
                style={{ left: '30%', top: 10 }}
            />
        </MenuItem>
    );
}
